import { ABOVE_DESKTOP_FULL_HD_CONTENT_WIDTH, media } from '@constants/layout.ts';
import styled from 'styled-components';

export const SplitScreenLayoutWrapper = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden;

    #image-side {
        flex: 1;
        height: 100%;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    #content-side {
        flex: 1;
        height: 100%;
        overflow: hidden;
        overflow-y: auto;
        position: relative;
    }

    @media ${media.aboveDesktopFullHD} {
        width: ${ABOVE_DESKTOP_FULL_HD_CONTENT_WIDTH}px;
        max-height: 100vh;
        margin: 0 auto;

        #image-side {
            flex: 2;
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;

        #image-side {
            height: 50vh;
            flex: 0 0 auto;
        }

        #content-side {
            height: 60vh;
            flex: 1;
            overflow-y: auto;
        }

        #footer-logo {
            margin-top: 40px;
        }
    }
`;
